<label *ngIf="label" [for]="id" [ngClass]="['control-label', _labelClass]">{{ label }} {{ _mandatory? '*' : '' }}</label>
<div [ngClass]="_fieldClass">
	<checkbox-list
		[id]="id"
		[wildcardOptionLabel]="wildcardOptionLabel"
		[itemList]="entities"
		[labelGetter]="getEntityLabel"
		[labelColorGetter]="getEntityColor"
		[titleGetter]="getEntityTitle"
		[preselectionFunction]="shouldBeSelectedByDefaut"
		[resetCommands]="_resetCommands"
		[selectionRequests]="selectionsSubject"
		[deselectionRequests]="deselectionsSubject"
		(itemDeselected)="itemDeselected.emit($event)"
		(itemSelected)="itemSelected.emit($event)"
		(selectedItemsChange)="onSelectionChange($event)"
		>
	</checkbox-list>
</div>